module.exports = __webpack_public_path__ + "static/media/KwikComfort Simplicity Statement on Use of Electronic Records.e1d78ade.pdf";